let key = 0;

export default () => {
  key = key + 1;
  return key;
};
